<template>
  <div class="cabecalho shadow-sm mb-2 bg-white">
    <img v-if="ar.logo !=null" class="logo" :src="'data:image/png;base64,' +  ar.logo" v-bind:title="ar.name" />
  </div>
</template>

<script>
export default {
  name: "cabecalho",
  props: ["ar"],
};
</script>

<style lang="scss" >
</style>




// WEBPACK FOOTER //
// src/components/Cabecalho.vue